<template>
  <modal v-model="show"
        max-width="500"
        title="Relatório de Campanha"
        contentClass="modal-visible">

    <template #activator>
      <svgicon slot="activator"
               icon="file-download-outline"
               v-tooltip="'Relatório de Campanhas'"
               width="26"
               height="26"
               color="#4b4b4b"></svgicon>
    </template>

    <template #default>
      <div class="advertising-partner-report-modal-body">
        <div class="period-filter-container">
          <div class="dates">
            <app-box-wrapper :data-label="$t('message.generics.message.startDate')"
                            data-icon="mdi-calendar-range">

              <app-date-picker v-model="form.startDate"                             
                              menu-width="auto"
                              ></app-date-picker>

            </app-box-wrapper>

            <app-box-wrapper :data-label="$t('message.generics.message.endDate')"
                            data-icon="mdi-calendar-range">

              <app-date-picker v-model="form.endDate"                              
                              menu-width="auto"
                              ></app-date-picker>

            </app-box-wrapper>
          </div>
        </div>

        <div class="establishment-filter-container">
          <establshiment-filter :establishmentsIds="form.establishments"
                                @input="setFilter($event, 'establishments')"></establshiment-filter> 
        </div>        
        
        <div class="advertising-filter-container">
          <app-advertising-filter :campaignsIds="form.campaigns"          
                                  with-treeselect
                                  :multiple="false"
                                  menuWidth="290px"
                                  @input="setFilter($event, 'campaigns')"></app-advertising-filter>
                           
        </div>

      </div>
    </template>

    <template #footer>
      <button class="btn btn-extra-round btn-primary" @click="downloadReport">
        Download
      </button>
    </template>
    
  </modal>
</template>
  
<script>
import Modal from "@/components/generic/Modal";
import AppAdvertisingFilter from "@components/filters/AdvertisingFilter";
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import EstablshimentFilter from "@components/filters/EstablshimentFilter";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Modal,
    AppAdvertisingFilter,
    AppBoxWrapper,
    AppDatePicker,
    EstablshimentFilter
    
  },

  data() {
    return {
      show: false,
      form: {
        startDate: new Date().toISOString().substring(0, 10),
        endDate: new Date().toISOString().substring(0, 10),
        establishments: [],
        campaigns: []
      }
    };
  },

  watch: {
    show(val) {
      if(val) this.resetData();
    }
  },

  props: {
    
  },

  computed: {
    
  },

  methods: {    
    emitInput(newVal) {      
      this.$emit("input", newVal);
    },
    async downloadReport() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        
        const excell = await this.$api.core.statistics.excellPartnerCampaignReport({ ...this.form });

        const link = this.createElementExcell(excell);

        link.click();
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
        this.show = false
      }
    },
    createElementExcell(excell) {
      const url = window.URL.createObjectURL(new Blob([excell]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "Excel-Campanhas-Parceiro.xls");
      document.body.appendChild(link);

      return link;
    },
    setFilter(val, type) {
      if(type === "establishments") {
        this.form.establishments = val
      } else {
        this.form.campaigns = val
      }
    },
    resetData() {
      this.form = {
        startDate: new Date().toISOString().substring(0, 10),
        endDate: new Date().toISOString().substring(0, 10),
        establishments: [],
        campaigns: []
      }
    }
  },
};
</script>
  
<style lang="scss" scoped>
@import "~@variables";
  .advertising-partner-report-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;

    .period-filter-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .dates {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 32px;

        .date {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1 0 auto;

          .datepicker-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 175px;
            height: 55px;
            padding: 0 15px;
            border: $border-1;
            border-radius: 4px;
            font-weight: bold;
            color: $grey-4;

            .mdi {
              font-size: 24px;
            }

            input {
              color: $grey-4;
            }
          }
        }
      }
    }    

    .establishment-filter-container {
      margin-bottom: 30px;
    }
  }
</style>
  
import { type } from "case";

